import Component, { ComponentAttrs } from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';

class UserBadge extends Component<{ badge: any }> {
  view() {
    // Hide badge when not enabled
    if (!this.attrs.badge.isVisible()) {
      return null;
    }

    // This badge is an image
    if (this.attrs.badge.image()) {
      return <img src={this.attrs.badge.image()} className={'UserBadgeImage'} />;
    }

    return (
      <span
        className={`UserBadge UserBadge-${this.attrs.badge.id()}`}
        style={{
          backgroundColor: this.attrs.badge.backgroundColor(),
          color: this.attrs.badge.labelColor(),
          borderColor: this.attrs.badge.backgroundColor(),
        }}
      >
        <i className={this.attrs.badge.icon()} style={{ color: this.attrs.badge.iconColor() }} /> {this.attrs.badge.name()}
      </span>
    );
  }
}

export default class UserInfo extends Component<ComponentAttrs> {
  view() {
    // app.badges
    return (
      <Link className="ExtraNav-user-container" href={app.session.user ? app.route.user(app.session.user) : '#'}>
        <div>
          <i class="icon fas fa-user"></i>
          <span>个人中心</span>
        </div>

        <div className="ExtraNav-user-badges">{this.badgesView()}</div>
      </Link>
    );
  }

  badgesView() {
    const user = app.session.user;

    // Don't show badges
    if (!user || !user.userBadges) {
      return null;
    }

    const userBadges = user.userBadges() ?? [];

    // No badges to show
    if (!userBadges || !userBadges.length) {
      return null;
    }

    // Check for all badges
    const visibleBadges = userBadges.slice(0, 3);

    return visibleBadges.map((userBadge) => {
      return <UserBadge badge={userBadge.badge()} />;
    });
  }
}
